import { Component } from "react";
import GlobalStyles from "./globalStyles";
import { ThemeProvider } from "styled-components";
import { light } from "./themes";

import Navigation from "./Components/Navigation";
import Home from "./Components/Sections/Home";
import About from "./Components/Sections/About";
import Faq from "./Components/Sections/Faq";
import Team from "./Components/Sections/Team";
import Footer from "./Components/Footer";


import "./Assets/css/Root.css";
import "./Assets/css/Routes.css";
import "./Assets/css/App.less";

class App extends Component {
  render() {
    return (
      <>
        <GlobalStyles />
        <ThemeProvider theme={light}>
          <Navigation />
          <Home />
          <About />
          <Team />
          <Faq />
          <Footer />
        </ThemeProvider>
      </>
    );
  }
}

export default App;